<template>
  <a-button @click="openModal" v-if="typebtn !== 'text'&&typebtn !== 'danger'" :type="typebtn">
    {{btnName}}
  </a-button>
  <a-button @click="openModal" v-if="typebtn == 'danger'" danger>
    {{btnName}}
  </a-button>
  <a
    v-if="typebtn == 'text'"
    href="javascript:void(0);"
    type="link"
    @click="openModal"
    class="theme-color"
    :style="btnName == '终止合同' ?{ color: '#2F7BFF'} : {color: '#ff4d4f'}"
  >
    {{btnName}}
  </a>
  <a-modal
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    v-model:visible="visible"
    title="终止合同"
    ok-text="确认"
    cancel-text="取消"
    @ok="ok"
  >
    <a-form layout="vertical" :model="formModel" ref="formRef" :rules="rules">
      <a-form-item label="终止合同原因分类" name="reason">
        <a-select
          placeholder="请选择"
          option-filter-prop="title"
          :value="formModel.reason"
          disabled
        >
          <a-select-option
            v-for="item in options"
            :key="item.code"
            :value="item.code"
            :title="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="终止合同原因">
        <a-textarea  placeholder="请输入项目关闭原因" v-model:value="formModel.remark" showCount :rows="4" :maxlength="200" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import { SignService } from "../sign-contract-btn/sign-contract-btn.service";
import { message } from "ant-design-vue";
import _ from "lodash"
const rules = {
  reason: [{ required: true, message: "请选择终止合同原因分类" }],
};
export default defineComponent({
  isGlobal: true,
  name: "TearContractBtn",
  props: {
    typebtn: {
      type: String,
      default: 'primary'
    },
    btnName: {
      type: String,
      default: '终止合同'
    },
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    contractStatus: {
      type: String,
    },
    flowStatus: {
      type: String,
    },
    formRef:{
      type:Object,
      default:()=>{
        return {}
      }
    },
  },
  emits: ["refresh"],
  setup(props,{emit}) {
    const state = reactive({
      formModel: reactive({
        reason: '签约失败',
        remark: '',
      }),
      options: reactive([ {code: 1, name: '签约失败'} ]),
    });

    const visible = ref(false);

    const { run, loading } = SignService.useContractStatusChangeApi();

    const openModal = () => {
      visible.value = true
      initStatus();
      state.formModel.remark = ''
    }

    const initStatus = () => {
      if (props.btnName == '终止合同') {
        if (props.flowStatus == 'spbtg' && props.contractStatus == 'dsp') {
          state.formModel.reason = '审批未通过'
          state.options = [{code: 1, name: '审批未通过'}]
        }
        if (props.flowStatus == 'sptg') {
          if (props.contractStatus == 'dly') {
            state.formModel.reason = '待履约时终止合同'
            state.options = [{code: 1, name: '待履约时终止合同'}]
          }
          if (props.contractStatus == 'lyz') {
            state.formModel.reason = '履约中终止合同'
            state.options = [{code: 1, name: '履约中终止合同'}]
          }
        }
      }
      if (props.btnName == '签约失败') {
        state.formModel.reason = '签约失败'
        state.options = [{code: 1, name: '签约失败'}]
      }
    }

    const ok = async () => {
      const res = await run([], props.bizId, props.bizType, '', 'yzz', state.formModel.reason, state.formModel.remark)
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return;
      }
      message.success(res.respDesc);
      emit("refresh", null);
      visible.value = false
    }

    onMounted(() => {
      initStatus();
    })
    
    return {
      ...toRefs(state),
      loading,
      visible,
      rules,
      openModal,
      ok
    }
  },
});
</script>